import ProtectedRoutes from "./auth/ProtectedRoutes";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Login from "./pages/login/Login";
import Home from "./pages/home/home";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<Home />} />
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
